export const PRICING_OPTIONS = {
  hourly: { label: 'Hourly', value: 'Hourly' },
  contact: { label: 'Contact for Pricing', value: null },
  range: { label: 'Labor Range', value: 'Labor Range' },
  estimate: { label: 'Labor Estimate', value: 'Labor Est' },
};
